<template>
    <v-app>
        <template v-if="loading">
            <v-main>
                <v-container fluid class="fill-height">
                    <v-row justify="center" align="center">
                        <v-col class="text-center" xs="12" md="12">
                            <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-col>

                        <v-col class="text-center">
                            {{ $t('app-layout.texts.loading-application') }}
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </template>

        <template v-else>
            <navigation-drawer
                :drawer="drawer"
                @change="drawerVisibilityChanged"
            ></navigation-drawer>
            <filter-drawer />

            <v-app-bar app class="elevation-0">
                <v-icon @click.stop="drawer = !drawer" class="mr-5">
                    {{ drawer ? 'mdi-menu-open' : 'mdi-menu' }}
                </v-icon>

                <v-toolbar-title>{{ applicationName }}</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <support-button />

                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-btn icon @click.prevent="logout" v-on="on">
                            <v-icon>mdi-logout-variant</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('app-layout.texts.exit') }}</span>
                </v-tooltip>
            </v-app-bar>

            <v-main>
                <template v-if="supportActive === 'movidesk'">
                    <movidesk-chat />
                </template>
                <template v-else>
                    <octadesk-chat />
                </template>

                <breadcrumb />
                <v-fade-transition hide-on-leave>
                    <router-view></router-view>
                </v-fade-transition>

                <notification-handler></notification-handler>

                <template v-if="resetPassword">
                    <user-edit></user-edit>
                </template>

                <template v-if="popup">
                    <popup :popup="popup"> </popup>
                </template>

                <cookies />
            </v-main>
        </template>
    </v-app>
</template>

<script>
import NavigationDrawer from '@/components/drawer/NavigationDrawer'
import FilterDrawer from '@/shared/components/filters/FilterDrawer'
import NotificationHandler from '@/components/notifications/NotificationHandler'
import UserEdit from '@/components/dialogs/UserEdit'
import Cookies from '@/components/dialogs/Cookies'
import Popup from '@/shared/components/Popup'
import { mapGetters } from 'vuex'
import SupportButton from '@/components/support/SupportButton'
import OctadeskChat from '@/components/support/OctadeskChat'
import MovideskChat from '@/components/support/MovideskChat'

export default {
    components: {
        'navigation-drawer': NavigationDrawer,
        FilterDrawer,
        'notification-handler': NotificationHandler,
        'user-edit': UserEdit,
        Cookies,
        Popup,
        'movidesk-chat': MovideskChat,
        'support-button': SupportButton,
        'octadesk-chat': OctadeskChat,
    },

    data: vm => {
        return {
            //Verifica o breakpoint para setar drawer aberto ou fechado ao iniciar a aplicação
            drawer:
                vm.$vuetify.breakpoint.name === 'xs' ||
                vm.$vuetify.breakpoint.name === 'sm'
                    ? false
                    : true,

            breadcrumbList: [],
            loading: true,
            popup: false,
            supportActive: process.env.VUE_APP_SUPPORT_ACTIVE,
        }
    },

    methods: {
        drawerVisibilityChanged(value) {
            this.drawer = value
        },

        async logout() {
            await this.$store.dispatch('auth/logout')

            this.$router.push({ name: 'login' })
        },

        setPopup() {
            if (!this.resetPassword && this.popups.length) {
                this.popup = this.popups[0]
            }
        },
    },

    async created() {
        this.loading = true
        if (this.authUser.id) {
            await this.$store.dispatch('reseller/getReseller')
            await this.$store.dispatch('auth/syncUser')
            await this.$store.dispatch('layout/syncPopups')
            this.setPopup()
        }
        this.loading = false

        setTimeout(() => {
            if (!this.popup && this.$route.query.from == 'changeEmail') {
                this.popup = {
                    title: this.$t('app-layout.texts.changedEmail'),
                    content: this.$t('app-layout.texts.changedEmail'),
                }
            }
        }, 1000)
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/user',
            popups: 'layout/popups',
            isWhitelabel: 'reseller/isWhitelabel',
        }),

        resetPassword() {
            return this.authUser.reset_password
        },

        applicationName() {
            return this.isWhitelabel
                ? this.$t('app-layout.texts.whitelabel')
                : this.$t('app-layout.texts.resale')
        },
    },
}
</script>
